'use strict';

export default class ContentFilter {
	constructor(params) {
		console.log(params);
		this.root = params.root;
	}

	init() {
		if (!this.root) return false;
		this._matchHTML();
		this._filter();
	}

	_matchHTML() {
		this.buttons = [...this.root.querySelectorAll('[data-content-filter-option]')];
		this.containers = [...this.root.querySelectorAll('[data-content-filter-container]')];
	}

	_filter() {
		if (!this.buttons.length) return false;

		this.buttons.forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();

				let btnId = btn.dataset.contentFilterOption;

				this.buttons.forEach(btn => {
					btn.classList.remove('active');
				});

				btn.classList.add('active');

				this.containers.forEach(container => {
					let containerIds = container.dataset.contentFilterContainer.split(',');

					container.style.display = 'none';

					containerIds.forEach(id => {
						if (id === btnId) {
							$(container).show();
						} else {
							if (btnId === 'all') {
								$(this.containers).show();
							}
						}
					})
				})
			})
		})
	}
}
